import { PRODUCT_STATUS } from "./constants";

export const normalizeProductStatus = (productStatus, defaultStatus) => {
    if (!productStatus || productStatus.status_name_eng === PRODUCT_STATUS.NONE) {
        return defaultStatus?.id || "";
    }

    return productStatus.id;
};

export const getProductStatusId = (product, defaultStatus) => {
    return normalizeProductStatus(product.status, defaultStatus);
};
